/**
 * @format
 * @Description: 已发消息请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';
import Cookie from 'js-cookie';
export default class MessageDetailServ {
  static getAppList(params) {
    return Request({
      url: `api/user/v1/application/tenant/${Cookie.get('tenant_id')}/instances`,
      method: 'GET',
      data: params
    });
  }
  static getListMessageType() {
    return Request({
      method: 'get',
      url: 'api/message/v1/template/msg-type/page'
    });
  }
  static getEventById(params) {
    return Request({
      url: `api/message/v1/event/${params.id}`,
      method: 'get'
    });
  }
  static saveForm(params) {
    if (params.isRelevanceTemplate == 1) {
      if (params.tabsVal == 3) {
        return {
          method: 'post',
          url: `api/message/v1/event/event/${params.eventId}/msgTemp/${params.originFormData.id}?msgType=${params.tabsVal}&targetChannels=${params.targetChannels}&channelId=`
        };
      } else {
        return {
          method: 'post',
          url: `api/message/v1/event/event/${params.eventId}/msgTemp/${params.originFormData.id}?msgType=${params.tabsVal}&targetChannels=${params.targetChannels}&channelId=${params.targetChannels}`
        };
      }
    } else {
      return {
        method: 'post',
        url: `api/message/v1/template/relate/event?eventId=${params.eventId}&targetChannels=${params.targetChannels}`
      };
    }
  }
  static send(params) {
    return {
      method: 'get',
      url: `api/message/v1/message/list`
    };
  }
  static getTemplateList(params) {
    return {
      url: 'api/message/v1/template/list',
      method: 'GET'
    };
  }
  static getParamList(params) {
    return {
      url: `api/message/v1/parameters/list`,
      method: 'GET'
    };
  }
  static deleteParam(params) {
    return {
      url: 'api/message/v1/parameters/{id}',
      method: 'delete'
    };
  }
  static saveTemplateForm(params) {
    return {
      url: 'api/message/v1/template',
      method: 'POST'
    };
  }

  static getListMessageChannel(params) {
    return Request({
      method: 'get',
      url: `api/message/v1/channel/page`,
      data: params
    });
  }
  //获取领域
  static getDomain(params) {
    return {
      url: 'api/basicdata/v1/meta/domain',
      method: 'GET'
    };
  }
  //获取实体
  static getEntity(params) {
    return {
      url: 'api/basicdata/v1/meta/entity',
      method: 'GET'
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/MessageManage/MessageDetail/MessageDetailServ.js